import React, { useEffect, useState } from "react";
import "./Navbar.css";
import bgimage from "../images/logoimage.jpg";
import bgimage2 from "../images/LogoDesign (1).png";
import favicon from "../images/favicon.png";
import {Link} from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [isMenuOpen]);

  return (
    <div className={`navbar ${isScrolled || isMenuOpen ? "navbar--scrolled" : ""}`}>
      <Link to='/' onClick={closeMenu} className="logo-link">
          <img src={bgimage2} class="logo" alt="Quinterra Logo" />
        <div className="logo_curve1_m"></div>
        <div className="logo_curve2_m"></div>
      </Link>

      <div className="menu-icon-wrapper">

      <div class="menu-icon" onClick={toggleMenu}>
        {isMenuOpen ? <CloseIcon  /> : <MenuIcon  />}

      </div>
      </div>

      {isMenuOpen && (
        <div class="menu-overlay" onClick={closeMenu}>
          <div class="menu-modal" onClick={(e) => e.stopPropagation()}>
            <div class="menu-content">
              <div className="menu-modal-shell">
                <div className="menu-modal-grid">
                  <div className="menu-card menu-card-products">
                    <ul>
                      <li class="menu-dropdown">
                        <span className="menu-label">Our Products</span>
                        <ul class="sub-menu product-sub-menu">
                          <li>
                            <a href="https://hr-assist.in/" target="_blank" rel="noreferrer" onClick={closeMenu} className="product-item">
                              <img src={favicon} alt="Quinterra product" className="product-item-icon" />
                              <span className="product-item-copy">
                                <span className="product-item-title">HR-ASSIST</span>
                                <span className="product-item-desc">AI-powered HRMS + ATS + CRM + Staffing platform for recruitment and workforce automation.</span>
                              </span>
                            </a>
                          </li>
                          <li>
                            <a
                              href="https://qshikshak.com/"
                              target="_blank"
                              rel="noreferrer"
                              onClick={closeMenu}
                              className="product-item"
                            >
                              <img src={favicon} alt="Qshikshak" className="product-item-icon" />
                              <span className="product-item-copy">
                                <span className="product-item-title">Qshikshak</span>
                                <span className="product-item-desc">AI-enabled School ERP for admissions, fees, academics, and administration.</span>
                              </span>
                            </a>
                          </li>
                          <li>
                            <Link to="/products" onClick={closeMenu} className="product-item">
                              <img src={favicon} alt="LeadGen AI" className="product-item-icon" />
                              <span className="product-item-copy">
                                <span className="product-item-title">LeadGen AI</span>
                                <span className="product-item-desc">AI-powered lead generation and enrichment for modern sales teams. Coming soon.</span>
                              </span>
                            </Link>
                          </li>
                          <li>
                            <Link to="/products" onClick={closeMenu} className="product-item">
                              <img src={favicon} alt="Land Intelligence" className="product-item-icon" />
                              <span className="product-item-copy">
                                <span className="product-item-title">Land Intelligence</span>
                                <span className="product-item-desc">Satellite-powered land intelligence for agriculture and risk detection. Coming soon.</span>
                              </span>
                            </Link>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>

                  <div className="menu-sales-strip menu-sales-strip-mobile">
                    <div className="menu-sales-copy">
                      <span className="menu-sales-title">Need a tailored solution?</span>
                      <span className="menu-sales-text">Let’s build the right digital product for your team, your users, and your business goals.</span>
                    </div>
                    <Link
                      to="/about"
                      state={{ scrollTo: "contact" }}
                      onClick={closeMenu}
                      className="menu-sales-button"
                    >
                      Talk to Sales
                    </Link>
                  </div>

                  <div className="menu-card menu-card-combined">
                    <div className="menu-combined-grid">
                      <ul>
                        <li class="menu-dropdown">
                          <span className="menu-label">Main</span>
                          <ul class="sub-menu">
                            <li>
                              <Link to="/home" onClick={closeMenu}>Home</Link>
                            </li>
                            <li>
                              <Link to="/technologies" onClick={closeMenu}>Technologies</Link>
                            </li>
                            <li>
                              <Link to="/about" onClick={closeMenu}>About</Link>
                            </li>
                            <li>
                              <Link to="/products" onClick={closeMenu}>Products</Link>
                            </li>
                          </ul>
                        </li>
                      </ul>

                      <ul>
                        <li class="menu-dropdown">
                          <span class="menu-label">Our Services</span>
                          <ul class="sub-menu">
                            <li>
                              <Link to="/mobile-app" onClick={closeMenu}>Mobile App</Link>
                            </li>
                            <li>
                              <Link to="/custom" onClick={closeMenu}>Custom Software Development</Link>
                            </li>
                            <li>
                              <Link to="/website" onClick={closeMenu}>Website Design & Development</Link>
                            </li>
                            <li>
                              <Link to="/ux-services" onClick={closeMenu}>UX & UI Services</Link>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </div>
                    <div className="menu-sales-strip menu-sales-strip-desktop">
                      <div className="menu-sales-copy">
                        <span className="menu-sales-title">Need a tailored solution?</span>
                        <span className="menu-sales-text">Let’s build the right digital product for your team, your users, and your business goals.</span>
                      </div>
                      <Link
                        to="/about"
                        state={{ scrollTo: "contact" }}
                        onClick={closeMenu}
                        className="menu-sales-button"
                      >
                        Talk to Sales
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
